export const data = [{
    "id": 1,
    "image": 1,
    "serial": "XYQEEZSGF3LW7",
    "brand": "DAHON",
    "model": "RXW - Women's - 2015",
    "price": 1549.99,
    "category": "sport",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 2,
    "image": 2,
    "serial": "27GVWN4QD68YV",
    "brand": "Hold Fast",
    "model": "Gala",
    "price": 2635.99,
    "category": "touring",
    "isInStock": false,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 3,
    "image": 3,
    "serial": "JZSPCS4XLPRUW",
    "brand": "Felt",
    "model": "RXW - Women's - 2015",
    "price": 479.99,
    "category": "cyclocross",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 4,
    "image": 4,
    "serial": "FEC3686PY99FY",
    "brand": "Pure Fix",
    "model": "Decree FRD",
    "price": 539.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 5,
    "image": 5,
    "serial": "QRT7UFF89HM3G",
    "brand": "DAHON",
    "model": "Straggler",
    "price": 7859.99,
    "category": "mountain",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 6,
    "image": 6,
    "serial": "ERZQ23KM76S62",
    "brand": "Surly",
    "model": "Lowside",
    "price": 3676.99,
    "category": "cyclocross",
    "isInStock": false,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 7,
    "image": 7,
    "serial": "585DN9SXSGUSS",
    "brand": "Felt",
    "model": "Decree FRD",
    "price": 8567.99,
    "category": "touring",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 8,
    "image": 8,
    "serial": "TNKCZEYNBYH37",
    "brand": "DAHON",
    "model": "Gala",
    "price": 149.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 9,
    "image": 9,
    "serial": "8NAZZPZ5YQG9E",
    "brand": "Surly",
    "model": "Big Dummy",
    "price": 4634.99,
    "category": "touring",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 10,
    "image": 10,
    "serial": "X8QPMWBZ7KE8P",
    "brand": "Hold Fast",
    "model": "Gala",
    "price": 4566.99,
    "category": "cyclocross",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 11,
    "image": 11,
    "serial": "SQ6N4HXV27ZDH",
    "brand": "Unknown",
    "model": "Krampus",
    "price": 5577.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 12,
    "image": 12,
    "serial": "JG9LDL3TRA56K",
    "brand": "DAHON",
    "model": "Decree FRD",
    "price": 1434.99,
    "category": "mountain",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 13,
    "image": 13,
    "serial": "7JBXGAC7H2LWT",
    "brand": "Raleigh",
    "model": "Decree FRD",
    "price": 3847.99,
    "category": "touring",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 14,
    "image": 14,
    "serial": "KMT5NGWQA339S",
    "brand": "DAHON",
    "model": "Ogre",
    "price": 6905.99,
    "category": "cyclocross",
    "isInStock": false,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 15,
    "image": 15,
    "serial": "J8HJ7EMLMARUK",
    "brand": "Pure Fix",
    "model": "Midnight Special",
    "price": 3738.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 16,
    "image": 16,
    "serial": "EYMUWX5CNBMNZ",
    "brand": "Felt",
    "model": "Decree FRD",
    "price": 1348.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 17,
    "image": 17,
    "serial": "EHNU54FQCFSJS",
    "brand": "Unknown",
    "model": "RXW - Women's - 2015",
    "price": 1222.99,
    "category": "touring",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 18,
    "image": 18,
    "serial": "Q3SGN2RL22YCP",
    "brand": "Surly",
    "model": "Redux 2",
    "price": 1738.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 19,
    "image": 19,
    "serial": "4536JHVTC7YN7",
    "brand": "Santa Cruz",
    "model": "Decree FRD",
    "price": 6887.99,
    "category": "cyclocross",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 20,
    "image": 20,
    "serial": "YAYWK8WV49749",
    "brand": "Pure Fix",
    "model": "Pack Rat",
    "price": 3677.99,
    "category": "touring",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 21,
    "image": 21,
    "serial": "2CMV96HAJEWLQ",
    "brand": "DAHON",
    "model": "Troll",
    "price": 567.99,
    "category": "mountain",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 22,
    "image": 22,
    "serial": "9M9KFL439MJ7W",
    "brand": "Hold Fast",
    "model": "Tamland - 2",
    "price": 7973.99,
    "category": "touring",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 23,
    "image": 23,
    "serial": "ANWT8CQNE9MKH",
    "brand": "DAHON",
    "model": "Pugsley",
    "price": 3785.99,
    "category": "sport",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 24,
    "image": 24,
    "serial": "D2UNFR2E4NJSE",
    "brand": "Santa Cruz",
    "model": "Redux 2",
    "price": 166.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 25,
    "image": 25,
    "serial": "85X67YFYTJB3P",
    "brand": "Raleigh",
    "model": "Decree FRD",
    "price": 34564.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 26,
    "image": 26,
    "serial": "SWMUC9ZPT4WLL",
    "brand": "Unknown",
    "model": "Tamland - 2",
    "price": 765.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 27,
    "image": 1,
    "serial": "XYQEEZSGF3LW7",
    "brand": "DAHON",
    "model": "RXW - Women's - 2015",
    "price": 1549.99,
    "category": "sport",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 28,
    "image": 2,
    "serial": "27GVWN4QD68YV",
    "brand": "Hold Fast",
    "model": "Gala",
    "price": 2635.99,
    "category": "touring",
    "isInStock": false,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 29,
    "image": 3,
    "serial": "JZSPCS4XLPRUW",
    "brand": "Felt",
    "model": "RXW - Women's - 2015",
    "price": 479.99,
    "category": "cyclocross",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 30,
    "image": 4,
    "serial": "FEC3686PY99FY",
    "brand": "Pure Fix",
    "model": "Decree FRD",
    "price": 539.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 31,
    "image": 5,
    "serial": "QRT7UFF89HM3G",
    "brand": "DAHON",
    "model": "Straggler",
    "price": 7859.99,
    "category": "mountain",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 32,
    "image": 6,
    "serial": "ERZQ23KM76S62",
    "brand": "Surly",
    "model": "Lowside",
    "price": 3676.99,
    "category": "cyclocross",
    "isInStock": false,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 33,
    "image": 7,
    "serial": "585DN9SXSGUSS",
    "brand": "Felt",
    "model": "Decree FRD",
    "price": 8567.99,
    "category": "touring",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 34,
    "image": 8,
    "serial": "TNKCZEYNBYH37",
    "brand": "DAHON",
    "model": "Gala",
    "price": 149.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 35,
    "image": 9,
    "serial": "8NAZZPZ5YQG9E",
    "brand": "Surly",
    "model": "Big Dummy",
    "price": 4634.99,
    "category": "touring",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 36,
    "image": 10,
    "serial": "X8QPMWBZ7KE8P",
    "brand": "Hold Fast",
    "model": "Gala",
    "price": 4566.99,
    "category": "cyclocross",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 37,
    "image": 11,
    "serial": "SQ6N4HXV27ZDH",
    "brand": "Unknown",
    "model": "Krampus",
    "price": 5577.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 38,
    "image": 12,
    "serial": "JG9LDL3TRA56K",
    "brand": "DAHON",
    "model": "Decree FRD",
    "price": 1434.99,
    "category": "mountain",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 39,
    "image": 13,
    "serial": "7JBXGAC7H2LWT",
    "brand": "Raleigh",
    "model": "Decree FRD",
    "price": 3847.99,
    "category": "touring",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 40,
    "image": 14,
    "serial": "KMT5NGWQA339S",
    "brand": "DAHON",
    "model": "Ogre",
    "price": 6905.99,
    "category": "cyclocross",
    "isInStock": false,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 41,
    "image": 15,
    "serial": "J8HJ7EMLMARUK",
    "brand": "Pure Fix",
    "model": "Midnight Special",
    "price": 3738.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 42,
    "image": 16,
    "serial": "EYMUWX5CNBMNZ",
    "brand": "Felt",
    "model": "Decree FRD",
    "price": 1348.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 43,
    "image": 17,
    "serial": "EHNU54FQCFSJS",
    "brand": "Unknown",
    "model": "RXW - Women's - 2015",
    "price": 1222.99,
    "category": "touring",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 44,
    "image": 18,
    "serial": "Q3SGNjRL22YCP",
    "brand": "Surly",
    "model": "Redux 2",
    "price": 1738.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 45,
    "image": 19,
    "serial": "4536dHVTC7YN7",
    "brand": "Santa Cruz",
    "model": "Decree FRD",
    "price": 6887.99,
    "category": "cyclocross",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 46,
    "image": 20,
    "serial": "YAYWK8hV49749",
    "brand": "Pure Fix",
    "model": "Pack Rat",
    "price": 3677.99,
    "category": "touring",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 47,
    "image": 21,
    "serial": "2CMV96HAJEWLQ",
    "brand": "DAHON",
    "model": "Troll",
    "price": 567.99,
    "category": "mountain",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 48,
    "image": 22,
    "serial": "9M9KFL439MJ7W",
    "brand": "Hold Fast",
    "model": "Tamland - 2",
    "price": 7973.99,
    "category": "touring",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 49,
    "image": 23,
    "serial": "ANWT8CQNE9MKH",
    "brand": "DAHON",
    "model": "Pugsley",
    "price": 3785.99,
    "category": "sport",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 50,
    "image": 24,
    "serial": "D2UNFR2E4NJSE",
    "brand": "Santa Cruz",
    "model": "Redux 2",
    "price": 166.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 51,
    "image": 25,
    "serial": "85X47YFYTJB3P",
    "brand": "Raleigh",
    "model": "Decree FRD",
    "price": 34564.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 52,
    "image": 26,
    "serial": "SWMHC9ZPT4WLL",
    "brand": "Unknown",
    "model": "Tamland - 2",
    "price": 765.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  },

  {
    "id": 53,
    "image": 10,
    "serial": "X8QPMWBZ7KE8P",
    "brand": "Hold Fast",
    "model": "Gala",
    "price": 4566.99,
    "category": "cyclocross",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 54,
    "image": 11,
    "serial": "SQ6N4HXV27ZDH",
    "brand": "Unknown",
    "model": "Krampus",
    "price": 5577.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 55,
    "image": 12,
    "serial": "JG9LDL3TRA56K",
    "brand": "DAHON",
    "model": "Decree FRD",
    "price": 1434.99,
    "category": "mountain",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 56,
    "image": 13,
    "serial": "7JBXGAC7H2LWT",
    "brand": "Raleigh",
    "model": "Decree FRD",
    "price": 3847.99,
    "category": "touring",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 57,
    "image": 14,
    "serial": "KMT5NGWQA339S",
    "brand": "DAHON",
    "model": "Ogre",
    "price": 6905.99,
    "category": "cyclocross",
    "isInStock": false,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 58,
    "image": 15,
    "serial": "J8HJ7EMLMARUK",
    "brand": "Pure Fix",
    "model": "Midnight Special",
    "price": 3738.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 59,
    "image": 16,
    "serial": "EYMUWX5CNBMNZ",
    "brand": "Felt",
    "model": "Decree FRD",
    "price": 1348.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 60,
    "image": 17,
    "serial": "EHNU54FQCFSJS",
    "brand": "Unknown",
    "model": "RXW - Women's - 2015",
    "price": 1222.99,
    "category": "touring",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 61,
    "image": 18,
    "serial": "Q3SGNjRL22YCP",
    "brand": "Surly",
    "model": "Redux 2",
    "price": 1738.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 62,
    "image": 19,
    "serial": "4536dHVTC7YN7",
    "brand": "Santa Cruz",
    "model": "Decree FRD",
    "price": 6887.99,
    "category": "cyclocross",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 63,
    "image": 20,
    "serial": "YAYWK8hV49749",
    "brand": "Pure Fix",
    "model": "Pack Rat",
    "price": 3677.99,
    "category": "touring",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 64,
    "image": 21,
    "serial": "2CMV96HAJEWLQ",
    "brand": "DAHON",
    "model": "Troll",
    "price": 567.99,
    "category": "mountain",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  },
  {
    "id": 65,
    "image": 22,
    "serial": "9M9KFL439MJ7W",
    "brand": "Hold Fast",
    "model": "Tamland - 2",
    "price": 7973.99,
    "category": "touring",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 66,
    "image": 23,
    "serial": "ANWT8CQNE9MKH",
    "brand": "DAHON",
    "model": "Pugsley",
    "price": 3785.99,
    "category": "sport",
    "isInStock": true,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 67,
    "image": 24,
    "serial": "D2UNFR2E4NJSE",
    "brand": "Santa Cruz",
    "model": "Redux 2",
    "price": 166.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": true
  },
  {
    "id": 68,
    "image": 25,
    "serial": "85X47YFYTJB3P",
    "brand": "Raleigh",
    "model": "Decree FRD",
    "price": 34564.99,
    "category": "mountain",
    "isInStock": false,
    "isNew": true,
    "isBestseller": false
  },
  {
    "id": 69,
    "image": 26,
    "serial": "SWMHC9ZPT4WLL",
    "brand": "Unknown",
    "model": "Tamland - 2",
    "price": 765.99,
    "category": "sport",
    "isInStock": true,
    "isNew": false,
    "isBestseller": false
  }
];